{
  "title": "Flash",
  "flashDocument": "Flash-dokument",
  "createAlertTitle": "Du oppretter en ny {{type}}",
  "alertDescription1": "Hvis du ikke velger en plan, vil det bli opprettet en ny plan med tilhørende oppgaver for deg.",
  "alertDescription2": "Denne {{documentType}} vil bli lagt til i en ny oppgave i den valgte planen.",
  "createQuickarticle": "Lag ny hurtigartikkel",
  "titles": {
    "newFlashTitle": "Lag ny Flash",
    "newHastTitle": "Lag ny HAST",
    "createAndSendType": "Opprett og send {{type}}",
    "createAndMarkTypeAsDone": "Opprett og legg {{type}} som klar",
    "approveType": "Godkjenn {{type}}",
    "shortFirstText": "Kort første tekst"
  },
  "promptDescriptions": {
    "newPlanningWillBeCreated": "En ny plan med tilhørende oppgaver for denne {{type}} vil bli opprettet for deg.",
    "typeWillBeAddedToPlanning": "Denne {{type}} vil bli lagt til i en ny oppgave i planen \"{{planningName}}\"",
    "alsoTypeCreated": "I samme plan vil det også bli lagt til en tekstoppdrag med {{type}}-innhold.",
    "alsoTypeCreatedWithApproved": "En ny, intern plan med tilhørende oppgaver for denne artikkelen vil bli opprettet for deg. Artikkelen vil ha statusen Godkjent. Husk å oppdatere og publisere planen!"
  },
  "operations": {
    "quickArticleCreated": "Hurtigartikkel opprettet"
  },
  "placeholders": {
    "flashTitle": "Flash-tittel",
    "sluggForTypes": "Stikkord for {{type1}} og {{type2}}",
    "hastTitle": "HAST-tittel"
  },
  "sendAsHast": "Send som HAST",
  "sendAsHastDescription": "Ved publisering skal denne artikkelen sendes som en HAST.",
  "hastLabel": "HAST",
  "hastDefaultPreamble": "Saken oppdateres",
  "removeHast": {
    "title": "Fjern HAST",
    "description": "Vil du fjerne HAST fra denne versjonen, eller fra hele artikkelen?",
    "fromVersion": "Denne versjonen",
    "fromArticle": "Hele artikkelen"
  }
}
